import React from 'react';
import { cm } from 'src/utils/classNames';
import SkeletonValuePlaceholder from '../SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import { PredictionMarketConfigs } from 'src/hooks/predictionMarkets/predictionMarketConfigs';
import Image from 'next/image';

export const PredictionMarketIcon = ({
	symbol,
	loading,
	small,
	className,
}: {
	symbol: string;
	loading?: boolean;
	small?: boolean;
	className?: string;
}) => {
	if (loading) {
		return (
			<SkeletonValuePlaceholder
				loading
				className={small ? 'h-4 w-4' : 'h-16 w-16'}
			/>
		);
	}

	return (
		<div
			className={cm(
				'relative flex shrink-0 items-center justify-center rounded-xs',
				small ? 'h-4 w-4' : 'h-16 w-16',
				className
			)}
		>
			<Image
				className="rounded-xs object-cover"
				src={
					PredictionMarketConfigs.getConfigFromMarketSymbol(symbol)?.imgSrc ??
					''
				}
				alt="Prediction Market Icon"
				fill
			/>
		</div>
	);
};
